import React from "react";
import clsx from "clsx";

interface ButtonProps {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary" | "outline";
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({ label, onClick, variant = "primary", fullWidth }) => {
  const base =
    "pointer-events-auto text-sm font-bold py-2 px-4 rounded-lg transform transition duration-150 ease-in-out hover:scale-105 active:scale-95";

  const variants: Record<typeof variant, string> = {
    primary: "bg-blue-500 text-white hover:bg-blue-600",
    secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300",
    outline: "border-2 border-blue-500 text-blue-500 hover:border-blue-700 hover:text-blue-700",
  };

  return (
    <button
      onClick={onClick}
      className={clsx(base, variants[variant], fullWidth && "w-full")}
    >
      {label}
    </button>
  );
};

export default Button;
